var _a, _b;
import { AutoRenewConfirmationDialogComponent } from './dialogs/auto-renew-confirmtion/auto-renew-confirmation.dialog';
import { CancelationInProgressDialogComponent } from './dialogs/cancellation-in-progress/cancellation-in-progress.dialog';
import { CancellationRequestDialogComponent } from './dialogs/cancellation-request/cancellation-request.dialog';
export var CANCELLATION_IN_PROGRESS_KEY = 'cancellationInProgress';
export var Countries;
(function (Countries) {
    Countries["UNITED_STATES"] = "us";
    Countries["MEXICO"] = "mx";
    Countries["PERU"] = "pe";
})(Countries || (Countries = {}));
export var AUTO_RENEW_UPDATE_COUNTRIES = [];
export var Flows;
(function (Flows) {
    Flows[Flows["AUTO_RENEW_UPDATE"] = 0] = "AUTO_RENEW_UPDATE";
    Flows[Flows["CANCELLATION_IN_PROGRESS"] = 1] = "CANCELLATION_IN_PROGRESS";
    Flows[Flows["CANCELLATION_REQUEST"] = 2] = "CANCELLATION_REQUEST";
})(Flows || (Flows = {}));
export var FLOWS_DIALOGS = (_a = {},
    _a[Flows.AUTO_RENEW_UPDATE] = AutoRenewConfirmationDialogComponent,
    _a[Flows.CANCELLATION_IN_PROGRESS] = CancelationInProgressDialogComponent,
    _a[Flows.CANCELLATION_REQUEST] = CancellationRequestDialogComponent,
    _a);
export var FLOWS_TRANSLATIONS = (_b = {},
    _b[Flows.AUTO_RENEW_UPDATE] = {
        title: 'rate_plan.auto_renew_modal.title',
        description: 'rate_plan.auto_renew_modal.description',
        confirm: 'rate_plan.auto_renew_modal.confirm',
        cancel: 'rate_plan.auto_renew_modal.cancel',
    },
    _b[Flows.CANCELLATION_IN_PROGRESS] = {
        title: 'rate_plan.cancellation_in_progress_modal.title',
        description: 'rate_plan.cancellation_in_progress_modal.description'
    },
    _b[Flows.CANCELLATION_REQUEST] = {
        title: 'rate_plan.cancellation_request_modal.title',
        description: 'rate_plan.cancellation_request_modal.description',
        phone: 'rate_plan.cancellation_request_modal.phone',
        confirm: 'rate_plan.cancellation_request_modal.confirm',
        editNumber: 'rate_plan.cancellation_request_modal.edit_number',
        confirmationTitle: 'rate_plan.cancellation_request_modal_confirmation.title',
        confirmationDescription: 'rate_plan.cancellation_request_modal_confirmation.description',
        confirmationClose: 'rate_plan.cancellation_request_modal_confirmation.close'
    },
    _b);
export var DIALOG_CONFIG = {
    disableClose: true,
    autoFocus: false
};
